const data = [
  {
    id: "1",
    name: "Jurek",
    age: "26",
    username: "jurek26",
  },
  {
    id: "2",
    name: "Anna",
    age: "34",
    username: "anna34",
  },
  {
    id: "3",
    name: "Bartek",
    age: "19",
    username: "bartek19",
  },
];

export default data;
